module.exports = __webpack_public_path__ + "static/media/foursquare.7ac6a856.svg";